export default "__VITE_ASSET__DqoPwPeF__"